/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery(document).ready(function(){
  //キャッシュ対策タイムスタンプ
  var timestamp = new Date().getTime();
  if(jQuery('img').hasClass('img-id')){
   jQuery(".img-id").each(function(i,e){
     jQuery(e).attr('src',jQuery(e).attr('src')+'?'+timestamp);
    });
  }

// scroll header navigation
var offset_sticky_header = 100;
var $header = jQuery('#section-header');
var $reverseSection = jQuery('.Header__reverseSection');
var offset_sticky_down = 0;

jQuery(window).scroll(function() {
  var currentTop = jQuery(window).scrollTop();

  // 下スクロール
  if (currentTop > offset_sticky_header && currentTop > offset_sticky_down) {
    $header.addClass('u-Sticky');

    if (jQuery('.CollectionToolbar').length > 0) {
      jQuery('.CollectionToolbar').css('top', $header.innerHeight() + 'px');
    }

    if (currentTop > offset_sticky_header + 150) {
      $header.removeClass('u-Sticky-up').addClass('u-Sticky-nav');
    }

    // 新セクション：下スクロール時に表示
    if (currentTop > offset_sticky_header + 150) {
      $reverseSection.addClass('is-show');
    } else {
      $reverseSection.removeClass('is-show');
    }
  }

  // 上スクロール
  else {
    if (
      currentTop > offset_sticky_header + 300 &&
      (currentTop - 150) + jQuery(window).height() < jQuery(document).height()
    ) {
      $header.addClass('u-Sticky-up');
    }

    // 新セクション：上スクロール時に非表示
    $reverseSection.removeClass('is-show');
  }

  // ページ上部では通常状態
  if (currentTop <= offset_sticky_down && currentTop <= offset_sticky_header) {
    $header
      .removeClass('u-Sticky-up')
      .removeClass('u-Sticky-nav')
      .removeClass('u-Sticky');

    $reverseSection.removeClass('is-show');
  }

  offset_sticky_down = currentTop;
});

  // scroll toolbar collection
  if (jQuery('.CollectionToolbar').length &&jQuery('.CollectionInner').length){
   jQuery(window).on('scroll', function () {
      if ((jQuery(window).scrollTop() +jQuery('.CollectionToolbar').height()) >jQuery('.CollectionInner').offset().top){
       jQuery('.CollectionToolbar').addClass('is-toolbar-scroll');
      } else {
       jQuery('.CollectionToolbar').removeClass('is-toolbar-scroll');
      }
    });


  }

  //delivery day


  if(jQuery('.ProductForm__Option.no-js').length){
    var $deliDay =jQuery('select[name="id"] option:selected').data('delivery-day');
    if($deliDay != ''){
     jQuery('.ProductMeta__InStock').append('<p id="date_of_shipment">発送日: '+ $deliDay +'</p>');
     jQuery('input[name="properties[発送日]"]').val($deliDay);
     jQuery('.ProductForm').append('<input type="hidden" name="properties[発送日]" value="'+ $deliDay +'">');
    }else{
//      jQuery('#date_of_shipment').remove();
     jQuery('input[name="properties[発送日]"]').remove();
    }

   jQuery('.SizeSwatch, .ColorSwatch').click(function(){
      setTimeout(function(){
        var $deliDay =jQuery('select[name="id"] option:selected').data('delivery-day');
        if($deliDay != ''){
          if(jQuery('input[name="properties[発送日]"]').length){
           jQuery('input[name="properties[発送日]"]').val($deliDay);
          }else{
           jQuery('#date_of_shipment').remove();
           jQuery('.ProductMeta__InStock').append('<p id="date_of_shipment">発送日: '+ $deliDay +'</p>');
           jQuery('.ProductForm').append('<input type="hidden" name="properties[発送日]" value="'+ $deliDay +'">')
          }
        }else{
         jQuery('#date_of_shipment').remove();
         jQuery('input[name="properties[発送日]"]').remove();
        }
      },0)
    })
  }

  //blog news
  var $status =jQuery('.c-new-blogs__countBox');
  var $slickElement =jQuery('.c-new-blogs');
  var $timelineBox =jQuery('.c-new-blogs__countBox');


  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    if(!slick.$dots){
      return;
    }

    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.html(i + ' <span class="c-new-blogs__counter"></span> ' + (slick.$dots[0].children.length));
  });

  $slickElement.slick({
    slidesToShow:1,
    slidesToScroll:1,
    arrows:true,
    fade:false,
    dots:true,
    autoplay: true,
    nextArrow:'<span class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="4.769" height="7.558" viewBox="0 0 4.769 7.558"><path id="Path_182" data-name="Path 182" d="M396.4,104.525l-3.284,3.284-3.284-3.284" transform="translate(-104.03 396.9) rotate(-90)" fill="none" stroke="#222" stroke-width="1.4"/></svg></span>',
    prevArrow:'<span class="prev-arrow"><svg class="" xmlns="http://www.w3.org/2000/svg" width="4.769" height="7.558" viewBox="0 0 4.769 7.558"><path id="Path_183" data-name="Path 183" d="M396.4,104.525l-3.284,3.284-3.284-3.284" transform="translate(108.799 -389.342) rotate(90)" fill="none" stroke="#222" stroke-width="1.4"/></svg></span>',
    appendArrows: '.c-new-blogs__arrow'
  });

  // scroll to top
  jQuery("#js-ScrollTop").on("click", function () {
    jQuery("html, body").animate({ scrollTop: 0 }, 1000);
  });

  //
  if(jQuery('.template-cart').length > 0){
    var checkDeliveryTime = setInterval(function() {
      var $item = jQuery('#cart-delivery-datetime_section_os2 .delivery-container');
      if ($item.length) {
        clearInterval(checkDeliveryTime);
        setTimeout(function(){
          jQuery('.Cart__delivery-datetime').append(jQuery('#cart-delivery-datetime_section_os2').parent());
        }, 500)
      }
    });
    var checkDeliveryTimeMindate = setInterval(function() {
      var $item = jQuery('.delivery-mindate-caution');
      if ($item.length) {
        clearInterval(checkDeliveryTimeMindate);
        var htmlDelivery = jQuery('.delivery-mindate-caution').html().replace('最短お届け可能日','最短発送日');
        jQuery('.delivery-mindate-caution').html(htmlDelivery);
      }
    });
    setTimeout(function(){
      window.wcpRefreshCartTotal();
    },5000)
  }

  function onChangeInventoryQuantity(){
   jQuery('.ProductForm__Option .Select select option').each(function(){
      const valueOption1 =jQuery(this).data('option1');
      const valueOption2 =jQuery(this).data('option2');
      const inventoryQuantity =jQuery(this).data('quantity');

      var $this =jQuery(this);
      if($this.attr('disabled')){
        if(jQuery('.ColorSwatchList').length > 0){
         jQuery('.ColorSwatchList li').each(function(){
            const option1 =jQuery(this);
            if(option1.find('input').is(":checked")){
             jQuery('.SizeSwatchList li').each(function(){
                const option2 =jQuery(this);
                const testOption1 = valueOption1+'-'+valueOption2;
                const testOption2 = option1.find('input').val()+'-'+option2.find('input').val();
                if(testOption1 == testOption2){
                  option2.find('.SizeSwatch').addClass('SoldOut');
                }
              });
            }
          });
        }
        else{
         jQuery('.SizeSwatchList li').each(function(){
            const option1 =jQuery(this);
            const testOption1 = valueOption1;
            const testOption2 = option1.find('input').val();
            if(testOption1 == testOption2){
              option1.find('.SizeSwatch').addClass('SoldOut');
            }
          });
        }
      }

      if(jQuery(this).is(':selected')){
        if(inventoryQuantity >= 11 ){
         jQuery('.ProductMeta__InStock p span').html('〇')
        }
        if (inventoryQuantity <= 10) {
         jQuery('.ProductMeta__InStock p span').html('残りわずか')
        }
        if (inventoryQuantity == 0){
         jQuery('.ProductMeta__InStock p span').html('✕')
        }
      }
    });
  }
  onChangeInventoryQuantity();
 jQuery(".ProductForm__Option .Select select").change(function() {
    onChangeInventoryQuantity();
  });


  // click dropdown filter
  try{
    FilterApi.afterCall = function(filter) {
      setTimeout(function() {
        if(jQuery('.Popover__ValueList').length){
          if(jQuery('.CollectionToolbar__Item--sort').length){
           jQuery('.CollectionToolbar__Item--sort').find('.c-sort-by').text(jQuery('.Popover__ValueList .Popover__Value.is-selected').text());
          }
        }
       jQuery('.Pagination__NavItem.Link').on('click', function(){
         jQuery('html, body').animate({
            scrollTop:jQuery('.CollectionMain').offset().top - 100
          }, 1000);
        })
      }, 0);

      var Dropdownfiltersp = setInterval(function(){
        if(jQuery('.boost-pfs-filter-button').length && !jQuery('.boost-pfs-filter-button').hasClass('open')){
          clearInterval(Dropdownfiltersp);
         jQuery('.boost-pfs-filter-button').off('click');
         jQuery('.boost-pfs-filter-button').on('click',function(){
            if(jQuery(this).hasClass('close')){
             jQuery(this).removeClass('close');
             jQuery(this).parents('.boost-pfs-filter-option').find('.boost-pfs-filter-option-title').removeClass('boost-pfs-filter-option-collapsed');
             jQuery(this).parent().next().find('.boost-pfs-filter-option-content-inner').slideDown();
            }else{
             jQuery(this).addClass('close');
             jQuery(this).parents('.boost-pfs-filter-option').find('.boost-pfs-filter-option-title').addClass('boost-pfs-filter-option-collapsed');
             jQuery(this).parent().next().find('.boost-pfs-filter-option-content-inner').slideUp();
            }
          });
        }
      }, 100);
      if(filter.event_type == 'collection'){
        location.reload();
      }

    }
  }catch(err){
    //console.log(err);
  }

  if(jQuery('.template-product').length){
    var checkReviewJudge = setInterval(function() {
      var $item =jQuery('#judgeme_product_reviews .jdgm-form');
      if ($item.length) {
        clearInterval(checkReviewJudge);
        var htmlReviewerName =jQuery('.jdgm-form__name-fieldset').html().replace('(', '').replace(')', '');
       jQuery('.jdgm-form__name-fieldset').html('');
       jQuery('.jdgm-form__name-fieldset').html(htmlReviewerName);
       jQuery('.jdgm-rev-widg__summary, .jdgm-widget-actions-wrapper').wrapAll("<div class='jdgm-widget-group' />");
       jQuery('.jdgm-submit-rev').wrap("<div class='jdgm-widget-submit_button' />")
//         if(jQuery('.jdgm-notification').length){
//          jQuery('.jdgm-notification').html('ありがとうございました！レビューを表示するには、しばらくしてからページを更新してください。');
//         }

       jQuery('.jdgm-form__reviewer-name-format-dropdown option').each(function(){
          var optionValue =jQuery(this).val();

         jQuery('.jdgm-form__reviewer-name-format-dropdown option').removeAttr("selected");
          if(optionValue == 'anonymous'){
           jQuery(this).attr('selected','selected')
          }
        })

       //jQuery('.jdgm-form__reviewer-name-format-dropdown option:first-child, .jdgm-form__reviewer-name-format-dropdown option[value="last_initial"], .jdgm-form__reviewer-name-format-dropdown option[value="all_initials"]').remove();


//         if(jQuery('.jdgm-rev__header').length){
//          jQuery('.jdgm-rev__header').append(jQuery('.jdgm-rev__timestamp'))
//         }
      }
    });

    var checkReviewJudgeNotification = setInterval(function() {
      var $item =jQuery('#judgeme_product_reviews .jdgm-notification');
      if ($item.length) {
        clearInterval(checkReviewJudgeNotification);
        setTimeout(function(){
         jQuery('.jdgm-notification').html('ありがとうございました！レビューを表示するには、しばらくしてからページを更新してください。');
        },100);
      }
    });

    if(jQuery('#date_of_shipment').length){
//       var valueDateShipment =jQuery('#date_of_shipment').attr('data-deliver');
//      jQuery('.ProductForm').append('<input type="hidden" name="properties[発送日]" value="'+ valueDateShipment +'">')
    }

    var checkBundleCart= setInterval(function() {
      var $item =jQuery('.th_pb_add_to_cart.button');
      if ($item.length) {
        clearInterval(checkBundleCart);
       jQuery('.th_pb_add_to_cart.button span.button_text').html('カートに入れる');
      }
    });

    //show popup add to cart
   jQuery('.ProductForm__AddToCart').click(function(event){
      // event.preventDefault();

      // var form =jQuery('form.ProductForm').serialize();

      // $.ajax({
      //   type: "POST",
      //   url: '/cart/add.js',
      //   data: form,
      //   success: function(data){
      //    jQuery('.Header__CartDot').addClass('is-visible');
      //    jQuery('body').addClass('no-scroll');
      //    jQuery('.js-showModal').attr('aria-hidden','false');
      //     setTimeout(function(){
      //      jQuery('.Modal__Content--icon').addClass('is-show');
      //     },300);
      //    jQuery('.PageOverlay').addClass('is-visible');
      //   },
      //   error: function(XMLHttpRequest, textStatus) {
      //     //console.log('error')
      //     Shopify.onError(XMLHttpRequest, textStatus);
      //   }
      // });
      //GA4　カート投入送信
      GA4_add_to_cart(jQuery('form.ProductForm select option').eq(　jQuery('form.ProductForm select').prop("selectedIndex")　　).data('sku')  ,"ItemName" ,jQuery('input[name="quantity"]').val()   );
    })
   jQuery('.js-CloseModal,.Modal__Close').click(function(){
     jQuery('.js-showModal').attr('aria-hidden','true');
      setTimeout(function(){
       jQuery('.Modal__Content--icon').removeClass('is-show');
      },300);
     jQuery('.PageOverlay').removeClass('is-visible');
     jQuery('body').removeClass('no-scroll');
     jQuery('html').removeClass('no-scroll');
    });
   jQuery(window).on('scroll', function () {
      if (jQuery(window).scrollTop() >jQuery('.Product').height() - 500){
       jQuery('.ScrollToShow_AddToCart').addClass('is-show');
      } else {
       jQuery('.ScrollToShow_AddToCart').removeClass('is-show');
      }
    });
   jQuery('.ScrollToShow__sectionVariant').click(function(){
     jQuery('html, body').animate({
        scrollTop:jQuery(".ProductForm__Variants").offset().top - 125
      }, 500);
    });
   jQuery('.ScrollToShow_AddToCart').click(function(){
     jQuery('html, body').animate({
        scrollTop:jQuery(".Product__Gallery").offset().top - 100
      }, 500);
    });
  }
  if(jQuery('.Product__Tabs').length){
   jQuery('.Product__Tabs .Collapsible__Button').click(function(){
     jQuery(this).toggleClass('is-active');
     jQuery(this).parent().find('.Collapsible__Inner').slideToggle();
    })

    if(jQuery('.Product__Tabs .Collapsible__Button.Collapsible__Button--show').length > -1){
     jQuery('.Product__Tabs .Collapsible__Inner.Collapsible__Inner--show').slideDown();
    }
  }

  if(jQuery('.template-login').length){
    if(location.href.indexOf('/account/login#recover') > 1){
     jQuery('#customer_login').hide();
     jQuery('#recover_customer_password').show();
    }
   jQuery('.js-ShowRecoverPassword').click(function(){
     jQuery('#customer_login').hide();
     jQuery('#recover_customer_password').show();
    })
   jQuery('#recover_customer_password button').click(function(){
      var newURL = location.href.split("#")[0];
      window.history.pushState('object', document.title, newURL);
    })
  }
  if(jQuery('.template-account').length){
    var checkShowVipApp = setInterval(function() {
      var $item =jQuery('.vipapp-block');
      if ($item.length) {
        clearInterval(checkShowVipApp);
       jQuery('.js-pointApp').append(jQuery('.vipapp-block__available-point-amount'))
      }
    });
  }
});


jQuery(document).ready(function () {
  // scroll top
 jQuery('.Guide__Sidebar--Menu li a').on('click', function (e) {
    var target = this.hash;
    var $target =jQuery(target);
    var width =jQuery(window).width();
    if (width >= 768) {
      var headerHeight = 90;
    } else if (width <= 768) {
      var headerHeight = 55;
    } else if (width <= 767) {
      var headerHeight = 53;
    }
   jQuery('html, body').stop().animate({
      'scrollTop': $target.offset().top - headerHeight
    }, 300, 'swing', function () {
    });
  });
});


jQuery(function () {
  jQuery(".Guide__Sidebar--Button").click(function(){
    jQuery(this).next(".Guide__Sidebar--Menu").slideToggle();
    jQuery(this).next(".Guide__Sidebar--Menu").siblings(".Guide__Sidebar--Menu").slideUp();
    jQuery(this).toggleClass("open");
    jQuery(this).siblings(".Guide__Sidebar--Title").removeClass("open");
  });

 jQuery( ".Guide__Sidebar--Item" ).each(function() {
    var txtTitle =jQuery(this).children('.Guide__Sidebar--Title').text();
   jQuery(this).children('.Guide__Sidebar--Title').html(txtTitle);
    var txtmenu =jQuery(this).children('.Guide__Sidebar--Menu').children('li');
    txtmenu.each(function() {
          var txta =jQuery(this).children('a').text();
     jQuery(this).children('a').html(txta);
    });
  });
});


//アコーディオン開閉
jQuery(document).ready(function () {
 jQuery(".accordion_ dt").on("click", function () {
   jQuery(this).next().slideToggle();
  });
});



//外部JS読み込み→write
/**
 * ファイル名を与えた JS ファイル内で document.write() された文字列を取得して、コールバック関数に渡す。
 * @param {string} fileName *.js ファイル名
 * @param {Function} callback コールバック関数。第一引数に結果を受け取る。
 */
function getWritten(fileName, callback) {
  var timestamp = new Date().getTime();
  var $iframe =jQuery("<iframe hidden\/>");
  $iframe.appendTo("body");
  var frameDocument = $iframe[0].contentWindow.document;
  var scriptTag = "<script src=\"" + fileName + "?" + timestamp + "\"><\/script>";
  frameDocument.open();
  $iframe[0].contentWindow.setResult = function(html) {
    $iframe.remove();
    callback(html.replace(scriptTag, ""));
  };
  frameDocument.write(
    "<div id=\"area-to-write\">" +
    scriptTag +
    "<\/div>" +
    "<script>" +
    "setResult(document.querySelector(\"#area-to-write\").innerHTML);" +
    "<\/script>"
  );
  frameDocument.close();
}


//コレクション＞フィルター内の「検索する」ボタンクリックでフィルター閉じる
window.addEventListener("load", function() {
  var element = document.getElementsByClassName( "boost-pfs-filter-button boost-pfs-filter-apply-button" ) ;
  for(var i = 0; i < element.length; i++){
    var htmltag = element[i];
    htmltag.dataset.action = 'close-drawer';
    htmltag.dataset.drawerId = 'collection-filter-drawer';
  }
});

//GA4　カート投入送信
 function GA4_add_to_cart(item_id,item_name,quantity){
    //alert(item_id + "  " + item_name  + "  "  + quantity);
   console.log(item_id + "  " + item_name  + "  "  + quantity);
    //start_for_GA4
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
    	event:"add_to_cart",
    	ecommerce:{
    		currency: "JPY",
    		value: "0",
    		items:[{
    			'item_id': item_id.substr( 0, 6 )  ,
    			'item_name': item_name,
    			'affiliation': "yumetenbo_official_Store",
    			'currency': "JPY",
    			'quantity': quantity
    		}]
    	} // ecommerce:{
    });
    //end_for_GA4
 }


//lazyに対応したアンカーリンク調整
jQuery(function () {
	var headerHight =jQuery("header").height();

	jQuery('a[href^="#"]').click(function(e) {
		var href =jQuery(this).attr("href");
		var target =jQuery(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - headerHight;

		$.when(
			jQuery("html, body").animate({
				scrollTop: position
			}, 400, "swing"),
			e.preventDefault(),
		).done(function() {
 			var diff = target.offset().top - headerHight;
 			if (diff === position) {
			} else {
				jQuery("html, body").animate({
				scrollTop: diff
				}, 10, "swing");
			}
		});
	});
});